import React from 'react';
import langs, { DEFAULT_LOCALE } from 'src/i18n/locales';
import PropTypes from 'prop-types';
import Head from 'next/head';

function Hreflangs({ routeContext }) {
    return (
        <Head>
            <link
              rel="alternate"
              hrefLang="x-default"
              href={`${routeContext.origin}${routeContext.path}`}
            />
            {Object.keys(langs).map((lang) => (
                <link
                  key={lang}
                  rel="alternate"
                  hrefLang={lang}
                  href={`${routeContext.origin}${lang === DEFAULT_LOCALE ? '' : `/${lang}`}${routeContext.path}`}
                />
            ))}
        </Head>
    );
}

Hreflangs.propTypes = {
    routeContext: PropTypes.shape({
        origin: PropTypes.string,
        path: PropTypes.string
    })
};

export default Hreflangs;
